import { render, staticRenderFns } from "./AddNewDevice.vue?vue&type=template&id=4f560c51&"
import script from "./AddNewDevice.vue?vue&type=script&lang=js&"
export * from "./AddNewDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports